import { Record, List } from 'immutable'
import { GALLERY_SLICED_OFFSET } from 'app/constants/api/galleries'

export const GalleryRecord = Record(
  {
    pending: false,
    images: List(),
    selected: false,
    loaded: false,
    imageToDelete: null,
    search: '',
    imageForReplace: null,
    isButtonDisable: true,
    lazyLoaded: GALLERY_SLICED_OFFSET,
  },
  'gallery'
)

export class Gallery extends GalleryRecord {}
